import { render, staticRenderFns } from "./FtFile.vue?vue&type=template&id=33cbee3f&scoped=true"
import script from "./FtFile.vue?vue&type=script&lang=js"
export * from "./FtFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cbee3f",
  null
  
)

export default component.exports